import React, { ReactElement } from 'react';
import { ContactProps } from './contact-types';
import ActionButtons from './fragments/action-buttons';
import SelectionCardContent from './fragments/selection-card-content';

export const Contact = ({
  contact,
  topLabel,
  onDelete,
  onEdit,
  hasTopActionButtons,
  testId,
  className,
}: ContactProps): ReactElement => {
  return (
    <>
      <SelectionCardContent contact={contact} topLabel={topLabel} testId={testId} />
      <ActionButtons
        contact={contact}
        onDelete={onDelete}
        onEdit={onEdit}
        hasTopActionButtons={hasTopActionButtons}
        className={className}
      />
    </>
  );
};

export default Contact;
